<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページはすべてのimgタグにalt属性が付与されています。
        </p>
        <p v-else>
          あなたのWebページは空または欠落しているalt属性が付与されたimgタグがあります。
        </p>
      </div>
    </li>
    <li v-if="checkAltAbnormalTags.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <dl>
          <dt>alt属性が空または欠落しているimgタグ</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in checkAltAbnormalTags" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <ol class="c-list--decimal">
          <li>異常なimgタグを上記にて確認をする。</li>
          <li>
            画像URLをコピーする。<br />
            例）&lt;img src="https://example.com/test.png" width="75"
            height="75" alt=""&gt;<br />
            test.pngをコピーして検索を行う。<br />
            注）全体をコピーすると、ランダムで値が入っている場合もあるので検索できない可能性がある。
          </li>
          <li>HPのソース（HTML）から該当箇所を確認し、修正を行う。</li>
        </ol>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    checkAltAbnormalTags() {
      if (this.detail.tags.abnormals) {
        return this.detail.tags.abnormals.filter(item => item);
      }
      return [];
    }
  }
};
</script>
